import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getQualitiesDataForLicensesFromGalleryPricing, qualityDataToString } from '../../../common/QualityImageData';
import SelectInput from './SelectInput';
import s from './pricingChooser.scss';
import { formatPriceFromLocaleInfo } from '../helpers/currencyHelpers';

function generatePricingValue(licenseId, qualityId) {
  return `${licenseId};${qualityId}`;
}

function renderer(op) {
  const { licenseName, qualityName, price } = op;

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div
        style={{ textOverflow: 'ellipsis', flexShrink: '1', maxWidth: '200px', overflow: 'hidden', whiteSpace: 'nowrap' }}
      >{`${licenseName} - ${qualityName}`}
      </div>
      <div style={{ width: '100px', paddingLeft: '10px' }}>{price}</div>
    </div>
  );
}

class PricingChooser extends Component {
  constructor() {
    super();

    this.state = {
      isOpen: false
    };
  }

  onOpen() {
    this.setState({ isOpen: true });
  }

  onClose() {
    this.setState({ isOpen: false });
  }

  render() {
    const {
      onPricingChanged,
      localeInfo,
      imageQualities,
      licenses,
      selectedLicenseId,
      selectedQualityId,
      itemWidth,
      itemHeight,
      galleryPricings,
      t
    } = this.props;

    const options = [];
    const selectedValue = generatePricingValue(selectedLicenseId, selectedQualityId);
    let currentImagePricingData = null;
    getQualitiesDataForLicensesFromGalleryPricing({
      itemWidth,
      itemHeight,
      imageQualities,
      licenses,
      galleryPricing: galleryPricings,
      callback: (licenseId, arrSupportedQualitiesData) => {
        const license = licenses.find(licenseInfo => licenseInfo.licenseId === licenseId);
        arrSupportedQualitiesData.forEach(data => {
          const { qualityData, quality } = data;
          const qualityId = quality.qualityId;
          const currentValue = generatePricingValue(license.licenseId, qualityId);
          if (currentValue === selectedValue) {
            currentImagePricingData = qualityDataToString(qualityData);
          }
          const option = {
            id: currentValue,
            licenseName: t(license.name),
            qualityName: t(quality.name),
            price: formatPriceFromLocaleInfo(quality.price, localeInfo),
            value: currentValue,
            licenseId: license.licenseId,
            qualityId,
            className: s.chooserLabel + ' shop-description'
          };
          options.push(option);
        });
      }
    });

    let chooserComponent = <div>There are no available licenses for this image</div>;
    if (currentImagePricingData) {
      chooserComponent = (
        <SelectInput
          onOpen={() => this.onOpen()}
          onClose={() => this.onClose()}
          searchable={false}
          menuContainerStyle={{ maxHeight: '3000px' }}
          valueRenderer={renderer}
          optionRenderer={renderer}
          clearable={false}
          wrapperStyle={{ height: '37px' }}
          source={options}
          selectedValue={selectedValue}
          onChange={option => onPricingChanged(option.licenseId, option.qualityId)}
        />
      );
    }

    return (
      <div
        onWheel={e => {
          if (this.state.isOpen) {
            e.stopPropagation();
          }
        }}
      >
        {chooserComponent}
      </div>
    );
  }
}
export default PricingChooser;

PricingChooser.propTypes = {
  onPricingChanged: PropTypes.func,
  localeInfo: PropTypes.any,
  imageQualities: PropTypes.array,
  licenses: PropTypes.array,
  selectedLicenseId: PropTypes.string,
  selectedQualityId: PropTypes.string,
  itemWidth: PropTypes.number,
  itemHeight: PropTypes.number,
  galleryPricings: PropTypes.any,
  t: PropTypes.any
};
